// import styles
import "./StampaSpese.css";

// import pacchetti
import React from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import format from "date-fns/format";
import { it } from "date-fns/locale";
import { downloadNotaSpesePdf } from "../../stampe/generatori/notaSpesePdf";

// import componenti
// import NotaSpese from "../../stampe/NotaSpese";

// import hooks
// import { useFirestore } from "../../hooks/useFirestore";
import { useCollection } from "../../hooks/useCollection";

const competenze = [
  { value: "Gennaio", label: "Gennaio" },
  { value: "Febbraio", label: "Febbraio" },
  { value: "Marzo", label: "Marzo" },
  { value: "Aprile", label: "Aprile" },
  { value: "Maggio", label: "Maggio" },
  { value: "Giugno", label: "Giugno" },
  { value: "Luglio", label: "Luglio" },
  { value: "Agosto", label: "Agosto" },
  { value: "Settembre", label: "Settembre" },
  { value: "Ottobre", label: "Ottobre" },
  { value: "Novembre", label: "Novembre" },
  { value: "Dicembre", label: "Dicembre" },
];

// Genera automaticamente gli anni da 2022 all'anno corrente + 2
const anniCompetenza = (() => {
  const annoIniziale = 2022;
  const annoCorrente = new Date().getFullYear();
  const anniTotali = [];

  for (let anno = annoIniziale; anno <= annoCorrente + 2; anno++) {
    anniTotali.push({
      value: anno.toString(),
      label: anno.toString(),
    });
  }

  return anniTotali;
})();

export default function StampaSpese() {
  // const { addDocument, response } = useFirestore("documenti");
  const { documents: utenti } = useCollection("users");
  const { documents: spese } = useCollection("spese");

  // state per controllare gli input
  const [competenza, setCompetenza] = useState("");
  const [annoCompetenza, setAnnoCompetenza] = useState("");
  const [owner, setOwner] = useState("");
  const [speseFiltrate, setSpeseFiltrate] = useState(null);
  const [speseModificabili, setSpeseModificabili] = useState(null);
  const [modalitaModifica, setModalitaModifica] = useState(false);

  const utentiConNotaSpesePeriodo = React.useMemo(() => {
    if (!spese || !utenti || !competenza?.value || !annoCompetenza?.value)
      return [];

    const monthKey = competenza.value.toLowerCase();
    const yearKey = annoCompetenza.value.toString();

    const userIdToLabel = new Map(
      utenti.map((u) => {
        const label =
          u?.anagrafica?.nome && u?.anagrafica?.cognome
            ? `${u.anagrafica.nome} ${u.anagrafica.cognome}`
            : u?.displayName || u?.id;
        return [u.id, label];
      }),
    );

    const userIds = new Set();
    spese.forEach((spesa) => {
      if (spesa?.pagamento !== "Nota Spese") return;
      const dateObj = spesa?.data?.toDate ? spesa.data.toDate() : null;
      if (!dateObj) return;

      const month = format(dateObj, "MMMM", { locale: it });
      const year = format(dateObj, "Y", { locale: it });
      if (month !== monthKey) return;
      if (year !== yearKey) return;

      const authorId = spesa?.autore?.id;
      if (!authorId) return;
      userIds.add(authorId);
    });

    return Array.from(userIds)
      .map((id) => ({ id, label: userIdToLabel.get(id) || id }))
      .sort((a, b) => a.label.localeCompare(b.label, "it"));
  }, [spese, utenti, competenza, annoCompetenza]);

  useEffect(() => {
    setOwner("");
  }, [competenza, annoCompetenza]);

  useEffect(() => {
    if (spese) {
      if (!owner?.value || !competenza?.value || !annoCompetenza?.value) {
        setSpeseFiltrate(null);
        setSpeseModificabili(null);
        setModalitaModifica(false);
        return;
      }

      const filtro = spese.filter((spesa) => {
        return (
          spesa.autore.id === owner.value &&
          format(spesa.data.toDate(), "MMMM", { locale: it }) ===
            competenza.value.toLowerCase() &&
          format(spesa.data.toDate(), "Y", { locale: it }) ===
            annoCompetenza.value.toString() &&
          spesa.pagamento === "Nota Spese"
        );
      });
      setSpeseFiltrate(filtro);

      // Crea una copia delle spese filtrate per la modifica
      if (filtro.length > 0) {
        const speseCopiatePerModifica = filtro.map((spesa) => ({
          ...spesa,
          descrizioneModificata: spesa.nome,
          protocolloModificato: spesa.protocollo || "",
        }));
        setSpeseModificabili(speseCopiatePerModifica);
      } else {
        setSpeseModificabili(null);
      }

      // Resetta la modalità modifica quando cambiano i filtri
      setModalitaModifica(false);
    }
  }, [spese, competenza, owner, annoCompetenza]);

  const handleDescrizioneChange = (index, nuovaDescrizione) => {
    const speseAggiornate = [...speseModificabili];
    speseAggiornate[index].descrizioneModificata = nuovaDescrizione;
    setSpeseModificabili(speseAggiornate);
  };

  const handleProtocolloChange = (index, nuovoProtocollo) => {
    const speseAggiornate = [...speseModificabili];
    speseAggiornate[index].protocolloModificato = nuovoProtocollo;
    setSpeseModificabili(speseAggiornate);
  };

  const toggleModalitaModifica = () => {
    setModalitaModifica(!modalitaModifica);
  };

  const confermaModifiche = () => {
    // Crea una copia delle spese originali ma con le descrizioni modificate
    const speseConDescrizioniModificate = speseFiltrate.map((spesa, index) => ({
      ...spesa,
      nome: speseModificabili[index].descrizioneModificata,
    }));

    setSpeseFiltrate(speseConDescrizioniModificate);
    setModalitaModifica(false);
  };

  // Stili personalizzati per react-select
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "40px !important",
      border: "1px solid #ddd !important",
      boxShadow: state.isFocused
        ? "0 0 0 1px #007bff !important"
        : "none !important",
      "&:hover": {
        borderColor: "#007bff !important",
      },
      width: "100% !important",
      borderColor: state.isFocused ? "#007bff !important" : "#ddd !important",
      padding: "0 !important",
      margin: "0 !important",
      backgroundColor: "#fff !important",
      color: "#333 !important",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10000,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 10000,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999 !important",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff !important"
        : state.isFocused
          ? "#f8f9fa !important"
          : "#fff !important",
      color: state.isSelected ? "#fff !important" : "#333 !important",
      "&:hover": {
        backgroundColor: "#f8f9fa !important",
        color: "#333 !important",
      },
    }),
  };

  return (
    <div className="stampa-spese-container">
      <h2 className="page-title">Stampa Nota Spese</h2>

      {/* Sezione filtri */}
      <div className="filtri-container">
        <div className="filtro-container">
          <div className="filtro-label-container">
            <label>Anno</label>
          </div>
          <div className="filtro-select-container">
            <Select
              onChange={(option) => setAnnoCompetenza(option)}
              options={anniCompetenza}
              isSearchable={false}
              styles={customSelectStyles}
              placeholder="Seleziona anno..."
              value={annoCompetenza}
            />
          </div>
        </div>

        <div className="filtro-container">
          <div className="filtro-label-container">
            <label>Mese</label>
          </div>
          <div className="filtro-select-container">
            <Select
              onChange={(option) => setCompetenza(option)}
              options={competenze}
              isSearchable={false}
              styles={customSelectStyles}
              placeholder="Seleziona mese..."
              value={competenza}
            />
          </div>
        </div>
      </div>

      {competenza?.value && annoCompetenza?.value && (
        <div className="utenti-periodo-container">
          <h3>
            Utenti con Nota Spese ({competenza.label} {annoCompetenza.label})
          </h3>
          {utentiConNotaSpesePeriodo.length > 0 ? (
            <div className="utenti-periodo-grid">
              {utentiConNotaSpesePeriodo.map((u) => (
                <button
                  key={u.id}
                  type="button"
                  className={`utenti-periodo-item ${
                    owner?.value === u.id ? "selected" : ""
                  }`}
                  onClick={() => setOwner({ value: u.id, label: u.label })}
                >
                  {u.label}
                </button>
              ))}
            </div>
          ) : (
            <div className="utenti-periodo-empty">
              Nessuna nota spese trovata per il periodo selezionato.
            </div>
          )}
        </div>
      )}

      {/* Sezione per visualizzare le spese filtrate */}
      {speseFiltrate && owner?.value && (
        <div className="anteprima-dati">
          <h3>
            Anteprima Spese ({speseFiltrate.length} elementi - Totale: €
            {speseFiltrate
              .reduce((acc, spesa) => acc + parseFloat(spesa.importo), 0)
              .toFixed(2)}
            )
          </h3>

          <div className="anteprima-contenuto">
            <p>
              <strong>Dipendente:</strong>{" "}
              {owner ? owner.label : "Non selezionato"}
            </p>
            <p>
              <strong>Periodo:</strong>{" "}
              {competenza ? competenza.label : "Non selezionato"}{" "}
              {annoCompetenza ? annoCompetenza.label : ""}
            </p>
            <p>
              <strong>Numero spese:</strong> {speseFiltrate.length}
            </p>
          </div>

          {speseFiltrate.length > 0 && (
            <div className="azioni-container">
              <button
                className="btn-mostra-anteprima"
                onClick={toggleModalitaModifica}
              >
                {modalitaModifica
                  ? "Annulla Modifiche"
                  : "Modifica Descrizioni"}
              </button>

              {modalitaModifica && (
                <button
                  className="btn-mostra-anteprima"
                  onClick={confermaModifiche}
                  style={{ marginLeft: "10px" }}
                >
                  Conferma Modifiche
                </button>
              )}
            </div>
          )}

          <div className="anteprima-tabella-container">
            <table className="anteprima-tabella">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Descrizione</th>
                  <th>Protocollo</th>
                  <th>Importo</th>
                  <th>Pagamento</th>
                </tr>
              </thead>
              <tbody>
                {modalitaModifica
                  ? // Visualizzazione in modalità modifica
                    speseModificabili.map((spesa, index) => (
                      <tr key={index}>
                        <td>{format(spesa.data.toDate(), "dd/MM/yyyy")}</td>
                        <td>
                          <input
                            type="text"
                            value={spesa.descrizioneModificata}
                            onChange={(e) =>
                              handleDescrizioneChange(index, e.target.value)
                            }
                            className="input-descrizione"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={spesa.protocolloModificato}
                            onChange={(e) =>
                              handleProtocolloChange(index, e.target.value)
                            }
                            className="input-protocollo"
                            style={{ width: "100px" }}
                          />
                        </td>
                        <td>€{spesa.importo}</td>
                        <td>{spesa.pagamento}</td>
                      </tr>
                    ))
                  : // Visualizzazione normale
                    speseFiltrate.map((spesa, index) => (
                      <tr key={index}>
                        <td>{format(spesa.data.toDate(), "dd/MM/yyyy")}</td>
                        <td>{spesa.nome}</td>
                        <td>{spesa.protocollo || "N/A"}</td>
                        <td>€{spesa.importo}</td>
                        <td>{spesa.pagamento}</td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {speseFiltrate && owner?.value && !modalitaModifica && (
        <div className="download-container">
          <button
            className="btn-download-pdf"
            onClick={() => {
              try {
                const autore = owner?.label || "Dipendente";
                const labelPeriodo = `${competenza?.label || "Mese"} ${
                  annoCompetenza?.label || ""
                }`.trim();
                const safeAutore = autore
                  .replace(/[^a-zA-Z0-9_-]/g, "_")
                  .substring(0, 50);
                const fileName = `NS_${safeAutore}_${labelPeriodo.replace(
                  /\s+/g,
                  "_",
                )}.pdf`;
                downloadNotaSpesePdf({
                  autore,
                  spese: speseFiltrate,
                  competenza: labelPeriodo,
                  fileName,
                });
              } catch (e) {
                console.error("Errore generazione Nota Spese PDF:", e);
              }
            }}
          >
            📄 Scarica Nota Spese PDF
          </button>
        </div>
      )}
    </div>
  );
}
